// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__HYXSN","inner":"Footer_inner__3is0O"};